const breakpoints = {
  tabletDesktop: 1060,
  mobileTablet: 760
};

const theme = {
  main: {
    colors: {
      water: "#a9dce3",
      waterLight: "#b2e0e6",
      crab: "#dc594b",
      crabPale: "#dc6862",
      ocean: "#23464e",
      oceanLight: "#3f7e8c",
      oceanLighter: "#5Cb7cc",
      oceanDark: "#1d3940",
      light: "#f5f9fa",
      vibrant1: "#3C64B4",
      vibrant2: "#5BC86B",
      vibrant3: "#71D0CB",
      vibrant4: "#CF6E99",
      vibrant5: "#BB893E",
    },
    maxWidths: {
      default: 1060,
      text: 760
    },
    breakpoints,
    mediaQueries: {
      mobile: `@media (max-width: ${breakpoints.mobileTablet}px)`,
      tablet: `@media (min-width: ${breakpoints.mobileTablet}px) and (max-width: ${breakpoints.tabletDesktop}px)`,
      mobileTablet: `@media (max-width: ${breakpoints.tabletDesktop}px)`,
      desktop: `@media (min-width: ${breakpoints.tabletDesktop}px)`
    }
  }
};

export default theme;


// WEBPACK FOOTER //
// ./src/styles/theme.js